module.exports = __webpack_public_path__ + "static/img/4.fa5160e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/17/zh/4.png
// module id = 2UUo
// module chunks = 0